import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import placeholder from "./placeholder.png";

class ScrollerItem extends Component {
  render() {
    const { language, category, selectedCategory, themeColor, hideThumbnail } =
      this.props;
    const isSelected = selectedCategory === category.id;
    const image =
      category.photo_thumb || category.photo_small || category.photo;
    return (
      <div
        style={{
          minWidth: "max-content",
          marginRight: 8,
          marginLeft: 8,
          justifySelf: "center",
          userSelect: "none",
          cursor: "pointer",
          opacity: isSelected ? 1 : 0.5,
        }}
        onClick={() => {
          this.props.setSelectedCategory(category.id);
        }}
      >
        {!hideThumbnail && (
          <img
            src={image && image?.startsWith("http") ? image : placeholder}
            style={{
              width: 70,
              height: 70,
              borderRadius: "50%",
              pointerEvents: "none",
              border: isSelected
                ? `2px solid ${themeColor}`
                : "1px solid #cecece",
              padding: 1,
              objectFit: "cover",
            }}
          />
        )}
        <p className="mb-0 mt-1 bold" style={{ fontSize: 13 }}>
          {language == "arabic" ? category.ar_name : category.name}
        </p>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    selectedCategory: state.selectedCategoryHeader.selectedCategory,
    themeColor: state.store.store.settings.dark,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedCategory: (id) =>
      dispatch({ type: "SET_SELECTED_CATEGORY", payload: id }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScrollerItem);
